import { RootState } from '@app/store';
import { useTypedSelector } from '@app/store/hooks/useTypedSelector';
import { timeZonesMain } from '@features/date-timezone-select';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DatetimeState {
  timeZone: string;
}

const initialTimezone = () => {
  const timezone =
    localStorage.getItem('timezone') || Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (timeZonesMain.includes(timezone)) return timezone;
  return 'UTC';
};

const initialState: DatetimeState = {
  timeZone: initialTimezone(),
};

const datetimeSlice = createSlice({
  name: 'datetime',
  initialState,
  reducers: {
    setTimeZone: (state, action: PayloadAction<{ timeZone: string }>) => {
      localStorage.setItem('timezone', action.payload.timeZone);
      state.timeZone = action.payload.timeZone;
    },
  },
});

export const actions = datetimeSlice.actions;
export default datetimeSlice.reducer;

export const useTimeZone = () => {
  return useTypedSelector((state: RootState) => state.datetime.timeZone);
};
